// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.T87WtE9bnvg1Tq6t {
  width: 456px !important;
  max-width: 100vw;
  background: rgba(236, 241, 255, 1) !important;
  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08) !important;
  border: none !important;
}

@media screen and (max-width: 1280px) {
  .T87WtE9bnvg1Tq6t:not(.hy07IuWd2mQ6OLlt) {
    height: calc(100vh - 65px) !important;
  }
}

.hy07IuWd2mQ6OLlt {
  width: 100vw !important;
  max-width: 100vw;
  left: 0 !important;
  right: auto !important;
  height: calc(100vh - 70px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;
}

@media screen and (max-width: 520px) {
  .hy07IuWd2mQ6OLlt {
    height: calc(100vh - 74px) !important;
  }
}

.T87WtE9bnvg1Tq6t .p-sidebar-header {
  display: none !important;
}

.T87WtE9bnvg1Tq6t .p-sidebar-content {
  padding: 32px 30px !important;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
}

.Ks26NtHDCpoJ4G6Z {
  display: flex;
  align-items: center;
}

.ZKmBnEUwJZgTUpL9 {
  width: 56px;
  height: 56px;
  border-radius: 100px;
  background: rgba(249, 249, 249, 1);
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 16px;
}

.l2alEQ_c8cZEiiW9 {
  width: 18px;
  height: 22px;
  display: block;
}

.KdlAUcuDbOohhhZF {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.lZYoFlWJelUufN4F {
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.d1fhF7lSodwYeGXI {
  text-transform: none;
}

.Ceu90qy3dvk3afKg {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  color: rgba(0, 0, 0, 0.7);
  word-break: break-word;
}

.aNxwSKq9JQQkairS {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
}

.rmZ3Mv6pP4ojEtdt {
  display: flex;
  flex-direction: column;
}

.RUexFWwkEYIrSLOH {
  width: 100%;
  min-height: 67px;
  padding: 24px 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0;
  text-transform: capitalize;
  color: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 12px;
  transition: background-color 0.15s;
  box-sizing: border-box;
}

.RUexFWwkEYIrSLOH:hover {
  background: rgba(0, 0, 0, 0.04);
}

.RUexFWwkEYIrSLOH:active,
.CPWsCiQjIchVI0co {
  color: rgba(32, 51, 108, 1);
}

.RUexFWwkEYIrSLOH:focus-visible {
  outline: 2px solid rgba(32, 51, 108, 0.4);
  outline-offset: -2px;
}

.jVxIod23PEVMMfMZ {
  gap: 8px;
}

.DoWOdGTePcAqeiYD {
  width: 20px;
  height: 20px;
  display: block;
}

`, "",{"version":3,"sources":["webpack://./src/components/CustomerMenu/CustomerMenu.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".sidebar {\r\n  width: 456px !important;\r\n  max-width: 100vw;\r\n  background: rgba(236, 241, 255, 1) !important;\r\n  box-shadow: -8px 0 24px rgba(0, 0, 0, 0.08) !important;\r\n  border: none !important;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .sidebar:not(.sidebarTop) {\r\n    height: calc(100vh - 65px) !important;\r\n  }\r\n}\r\n\r\n.sidebarTop {\r\n  width: 100vw !important;\r\n  max-width: 100vw;\r\n  left: 0 !important;\r\n  right: auto !important;\r\n  height: calc(100vh - 70px) !important;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08) !important;\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .sidebarTop {\r\n    height: calc(100vh - 74px) !important;\r\n  }\r\n}\r\n\r\n.sidebar :global(.p-sidebar-header) {\r\n  display: none !important;\r\n}\r\n\r\n.sidebar :global(.p-sidebar-content) {\r\n  padding: 32px 30px !important;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.userRow {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.avatar {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 100px;\r\n  background: rgba(249, 249, 249, 1);\r\n  padding: 8px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  margin-right: 16px;\r\n}\r\n\r\n.avatarIcon {\r\n  width: 18px;\r\n  height: 22px;\r\n  display: block;\r\n}\r\n\r\n.userText {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-width: 0;\r\n}\r\n\r\n.greeting {\r\n  font-family: Montserrat, sans-serif;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(0, 0, 0, 1);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.wave {\r\n  text-transform: none;\r\n}\r\n\r\n.email {\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  color: rgba(0, 0, 0, 0.7);\r\n  word-break: break-word;\r\n}\r\n\r\n.divider {\r\n  height: 1px;\r\n  background: rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.navItem {\r\n  width: 100%;\r\n  min-height: 67px;\r\n  padding: 24px 30px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-family: Roboto, sans-serif;\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  line-height: 120%;\r\n  letter-spacing: 0;\r\n  text-transform: capitalize;\r\n  color: rgba(0, 0, 0, 1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  border-radius: 12px;\r\n  transition: background-color 0.15s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.navItem:hover {\r\n  background: rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.navItem:active,\r\n.navItemActive {\r\n  color: rgba(32, 51, 108, 1);\r\n}\r\n\r\n.navItem:focus-visible {\r\n  outline: 2px solid rgba(32, 51, 108, 0.4);\r\n  outline-offset: -2px;\r\n}\r\n\r\n.logout {\r\n  gap: 8px;\r\n}\r\n\r\n.logoutIcon {\r\n  width: 20px;\r\n  height: 20px;\r\n  display: block;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export var sidebar = `T87WtE9bnvg1Tq6t`;
export var sidebarTop = `hy07IuWd2mQ6OLlt`;
export var userRow = `Ks26NtHDCpoJ4G6Z`;
export var avatar = `ZKmBnEUwJZgTUpL9`;
export var avatarIcon = `l2alEQ_c8cZEiiW9`;
export var userText = `KdlAUcuDbOohhhZF`;
export var greeting = `lZYoFlWJelUufN4F`;
export var wave = `d1fhF7lSodwYeGXI`;
export var email = `Ceu90qy3dvk3afKg`;
export var divider = `aNxwSKq9JQQkairS`;
export var nav = `rmZ3Mv6pP4ojEtdt`;
export var navItem = `RUexFWwkEYIrSLOH`;
export var navItemActive = `CPWsCiQjIchVI0co`;
export var logout = `jVxIod23PEVMMfMZ`;
export var logoutIcon = `DoWOdGTePcAqeiYD`;
export default ___CSS_LOADER_EXPORT___;
